import { useAnalytics } from "@codat/analytics";
import { ButtonImage } from "api/company";
import classNames from "classnames";
import { useState } from "react";

import styles from "./ImageButton.module.css";

interface ImageButtonProps extends React.ComponentProps<"button"> {
  image: ButtonImage;
  analyticsName: string;
  eventProperties?: object;
}

export const ImageButton: React.FC<ImageButtonProps> = ({
  image,
  analyticsName,
  eventProperties,
  onClick,
  ...buttonProps
}) => {
  const [displayedImage, setDisplayedImage] = useState(image.default.image);

  const analytics = useAnalytics();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    analytics.sendEvent(`${analyticsName} button - Clicked`, eventProperties);

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      {...buttonProps}
      className={classNames(styles.button, buttonProps.className)}
      onClick={handleClick}
    >
      <img
        src={displayedImage.src}
        alt={displayedImage.alt}
        onMouseOver={() => setDisplayedImage(image.hover.image)}
        onMouseOut={() => setDisplayedImage(image.default.image)}
      />
    </button>
  );
};
